import React, { useState, useEffect, useRef } from 'react';
import { Input as $Input } from 'antd';

import { OnBlurCallback, OnChangeCallback, FormElementChangeEvent } from '.';

import Input, { InputProps } from './input';

export const format = (value: string, mask: string) => {
  if (!value) return '';
  let i = 0;
  let lastReplacedIndex = -1;
  const filledMask = mask.replace(/X/g, (_, j) => {
    if (i >= value.length) {
      return 'X';
    }
    lastReplacedIndex = j;
    return value[i++];
  });
  return filledMask.substring(0, lastReplacedIndex + 1);
};

export type PhoneNumberProps = Omit<InputProps, 'onChange' | 'onBlur' | 'value'> & {
  name: string;
  onBlur?: OnBlurCallback;
  onChange?: OnChangeCallback;
  value: string;
};

const PhoneNumber = React.memo(function PhoneNumber({ name, onChange, value, ...props }: PhoneNumberProps) {
  const [currentValue, setCurrentValue] = useState(value);
  const mask = '(XXX) XXX-XXXX';
  const inputRef: React.RefObject<$Input> = useRef<$Input>(null);
  const handleChange =
    onChange &&
    (({ name, value, selectionStart }: FormElementChangeEvent) => {
      let cleanValue = value && value.replace(/[^\d]/g, '').substring(0, 10);
      if (value === '(') {
        cleanValue = undefined;
      }
      onChange({ name, value: cleanValue });
      const element = inputRef?.current?.input;
      if (element && selectionStart !== undefined && selectionStart < element.value.length) {
        requestAnimationFrame(() => {
          element.selectionStart = selectionStart;
          element.selectionEnd = selectionStart;
        });
      }
    });

  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value, currentValue]);

  return (
    <Input
      {...props}
      name={name}
      onChange={handleChange}
      placeholder={mask}
      value={format(currentValue, mask)}
      ref={inputRef}
    />
  );
});

export default PhoneNumber;
